module.exports = __webpack_public_path__ + "static/img/customer.6135722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/customer.png
// module id = FeMY
// module chunks = 156